import { FormattedMessage } from 'react-intl';

import OutlineLabel from '@/features/engineoil/components/OutlineLabel';

const TBM3SsSeriesPreconditions = () => (
    <div>
        <div className="text-bold">
            <FormattedMessage id="intl-msg:engineOil.preconditions.dialog.subtitle" />
        </div>
        <ol className="margin-top-25">
            <li className="margin-x-10 padding-y-10">
                <div className="display-flex justify-content-between align-items-center">
                    <span>
                        <FormattedMessage
                            id="intl-msg:engineOil.preconditions.ssSeries.static.tbm3.standingTime"
                            values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
                        />
                    </span>
                    <OutlineLabel variant="primary">
                        <FormattedMessage id="intl-msg:engineOil.preconditions.ssSeries.static.checkedByServiceCare" />
                    </OutlineLabel>
                </div>
            </li>
            <li className="margin-x-10 padding-y-10">
                <FormattedMessage id="intl-msg:engineOil.preconditions.ssSeries.static.signalReceived" />
            </li>
        </ol>
        <ol className="bg-lightest" start={3}>
            <li className="margin-x-10 padding-y-10">
                <div className="display-flex justify-content-between align-items-center">
                    <FormattedMessage id="intl-msg:engineOil.preconditions.ssSeries.static.flatSurface" />
                    <OutlineLabel variant="primary">
                        <FormattedMessage id="intl-msg:engineOil.preconditions.ssSeries.static.ensuredByOperator" />
                    </OutlineLabel>
                </div>
            </li>
            <li className="margin-x-10 padding-y-10">
                <FormattedMessage
                    id="intl-msg:engineOil.preconditions.ssSeries.static.ignitionOn"
                    values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
                />
            </li>
            <li className="margin-x-10 padding-y-10">
                <FormattedMessage id="intl-msg:engineOil.preconditions.ssSeries.static.engineNotRunning" />
            </li>
        </ol>
    </div>
);

export default TBM3SsSeriesPreconditions;
